export default __webpack_public_path__ + "static/media/mk.39a80c62.svg";